/* =========================================================================
   TS NAV — Rollout 1: header + mega menu on the Symmetry theme (no dependencies).
   Hover intent + click + keyboard mega panels, condensed/hide-on-scroll header, mobile drawer,
   search overlay (the store's search app powers suggestions), "ways to wear it" panels,
   and the bag count kept in sync with Symmetry's add-to-cart.
   ========================================================================= */
(function () {
  'use strict';
  var TSM = (window.TSM = window.TSM || {});
  var routes = TSM.routes || { cartJs: '/cart.js', search: '/search', predictive: '/search/suggest.json' };
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  function lockScroll(lock) { document.documentElement.style.overflow = lock ? 'hidden' : ''; }
  function trapFocus(container, e) {
    var f = $$('a[href], button:not([disabled]), input, select, [tabindex]:not([tabindex="-1"])', container).filter(function (el) { return el.offsetParent !== null; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }
  function escapeHtml(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  /* ---------- Bag count (Symmetry fires theme:cartchanged after its ajax add) ---------- */
  function refreshCount(bump) {
    return fetch(routes.cartJs, { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      $$('[data-tsm-cart-count]').forEach(function (el) {
        el.textContent = cart.item_count;
        el.classList.toggle('is-empty', cart.item_count === 0);
        if (bump) { el.classList.remove('is-bump'); void el.offsetWidth; el.classList.add('is-bump'); }
      });
    }).catch(function () {});
  }

  /* ---------- Header ---------- */
  function initHeader() {
    var wrap = $('[data-tsm-header]');
    if (!wrap || wrap.dataset.tsmInit) return;
    wrap.dataset.tsmInit = '1';
    var setH = function () { document.documentElement.style.setProperty('--tsm-header-h', wrap.offsetHeight + 'px'); };
    setH(); window.addEventListener('resize', setH);

    var lastY = window.scrollY, ticking = false;
    function onScroll() {
      var y = window.scrollY, open = wrap.classList.contains('has-open');
      wrap.classList.toggle('is-condensed', y > 60);
      if (!open) wrap.classList.toggle('is-hidden', y > 420 && y > lastY + 4);
      if (y < lastY - 4) wrap.classList.remove('is-hidden');
      lastY = y; ticking = false;
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } }, { passive: true });
    onScroll();

    var items = $$('[data-tsm-nav-item].has-panel', wrap);
    var openTimer, closeTimer, current = null;
    function open(item) {
      if (current === item) return;
      if (current) close(current, true);
      current = item;
      item.classList.add('is-open');
      var link = $('.tsm-nav__link', item); link && link.setAttribute('aria-expanded', 'true');
      wrap.classList.add('has-open'); wrap.classList.remove('is-hidden');
    }
    function close(item, swapping) {
      item.classList.remove('is-open');
      var link = $('.tsm-nav__link', item); link && link.setAttribute('aria-expanded', 'false');
      if (current === item) current = null;
      if (!swapping) wrap.classList.remove('has-open');
    }
    items.forEach(function (item) {
      var link = $('.tsm-nav__link', item);
      if (finePointer) {
        item.addEventListener('mouseenter', function () { clearTimeout(closeTimer); clearTimeout(openTimer); openTimer = setTimeout(function () { open(item); }, current ? 0 : 140); });
        item.addEventListener('mouseleave', function () { clearTimeout(openTimer); closeTimer = setTimeout(function () { close(item); }, 220); });
      }
      // first tap opens the panel (touch laptops/tablets); a second tap follows the link
      link.addEventListener('click', function (e) { if (!item.classList.contains('is-open')) { e.preventDefault(); open(item); } });
      link.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown' || e.key === ' ') { e.preventDefault(); open(item); var first = $('.tsm-mega a', item); first && first.focus(); }
      });
      item.addEventListener('focusout', function (e) { if (!item.contains(e.relatedTarget)) close(item); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && current) { var l = $('.tsm-nav__link', current); close(current); l && l.focus(); }
    });
    var scrim = $('[data-tsm-scrim]', wrap);
    scrim && scrim.addEventListener('click', function () { current && close(current); });

    initWear(wrap);
    document.addEventListener('theme:cartchanged', function () { refreshCount(true); });
    window.addEventListener('pageshow', function (e) { if (e.persisted) refreshCount(false); });
  }

  /* ---------- "Ways to wear it" panels: the hovered (or focused) one opens ---------- */
  function initWear(ctx) {
    $$('[data-tsm-wear]', ctx).forEach(function (g) {
      var panels = $$('[data-tsm-wear-panel]', g);
      function activate(p) { panels.forEach(function (x) { x.classList.toggle('is-active', x === p); }); }
      panels.forEach(function (p) {
        p.addEventListener('mouseenter', function () { activate(p); });
        p.addEventListener('focus', function () { activate(p); });
        // on touch, the first tap opens a closed panel instead of navigating
        p.addEventListener('click', function (e) { if (!p.classList.contains('is-active')) { e.preventDefault(); activate(p); } });
      });
    });
  }

  /* ---------- Mobile drawer ---------- */
  function initDrawer() {
    var drawer = $('[data-tsm-drawer]');
    if (!drawer || drawer.dataset.tsmInit) return;
    drawer.dataset.tsmInit = '1';
    var opener = $('[data-tsm-drawer-open]');
    function openD() {
      drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); opener && opener.setAttribute('aria-expanded', 'true'); lockScroll(true);
      setTimeout(function () { var c = $('[data-tsm-drawer-close]', drawer); c && c.focus(); }, 50);
    }
    function closeD() {
      drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); opener && opener.setAttribute('aria-expanded', 'false'); lockScroll(false);
      opener && opener.focus();
    }
    opener && opener.addEventListener('click', openD);
    $$('[data-tsm-drawer-close]', drawer).forEach(function (b) { b.addEventListener('click', closeD); });
    drawer.addEventListener('click', function (e) { if (e.target === drawer) closeD(); });
    drawer.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeD(); if (e.key === 'Tab') trapFocus($('.tsm-drawer__panel', drawer), e); });
    $$('[data-tsm-acc]', drawer).forEach(function (btn) {
      btn.addEventListener('click', function () { btn.setAttribute('aria-expanded', btn.getAttribute('aria-expanded') === 'true' ? 'false' : 'true'); });
    });
  }

  /* ---------- Search overlay ---------- */
  function initSearch() {
    var panel = $('[data-tsm-search]');
    if (!panel || panel.dataset.tsmInit) return;
    panel.dataset.tsmInit = '1';
    var input = $('[data-tsm-search-input]', panel), results = $('[data-tsm-search-results]', panel), popular = $('[data-tsm-search-popular]', panel);
    var openers = $$('[data-tsm-search-open]');
    function openS() { panel.classList.add('is-open'); panel.setAttribute('aria-hidden', 'false'); lockScroll(true); setTimeout(function () { input.focus(); }, 120); }
    function closeS() { panel.classList.remove('is-open'); panel.setAttribute('aria-hidden', 'true'); lockScroll(false); openers[0] && openers[0].focus(); }
    openers.forEach(function (b) { b.addEventListener('click', openS); });
    $$('[data-tsm-search-close]', panel).forEach(function (b) { b.addEventListener('click', closeS); });
    panel.addEventListener('click', function (e) { if (e.target === panel) closeS(); });
    panel.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeS(); });

    // If a search app (Searchanise) is really loaded, it attaches its own suggestions to this field.
    // (theme.liquid also sets a stale window.SearchaniseIncluded flag, so check for the app itself.)
    if (panel.dataset.appSearch === 'true' && (window.Searchanise || document.querySelector('script[src*="searchanise"], script[src*="searchserverapi"]'))) return;
    var timer;
    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < 2) { results.innerHTML = ''; popular.hidden = false; return; }
      timer = setTimeout(function () {
        fetch(routes.predictive + '?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last')
          .then(function (r) { return r.json(); }).then(function (data) {
            var products = (data.resources && data.resources.results && data.resources.results.products) || [];
            popular.hidden = true;
            if (!products.length) { results.innerHTML = '<p>Nothing found for “' + escapeHtml(q) + '”.</p>'; return; }
            results.innerHTML = '<div class="tsm-search__grid">' + products.map(function (p) {
              var img = (p.featured_image && p.featured_image.url) || p.image || '';
              if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=400';
              return '<a class="tsm-search__item" href="' + p.url + '"><img src="' + img + '" alt="" loading="lazy"><span>' + escapeHtml(String(p.title).split(' (')[0]) + '</span></a>';
            }).join('') + '</div>';
          }).catch(function () {});
      }, 220);
    });
  }

  function boot() { initHeader(); initDrawer(); initSearch(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  // Theme editor: re-init when the header section is re-rendered
  document.addEventListener('shopify:section:load', function (e) { if (e.target.querySelector('[data-tsm-header]')) boot(); });
})();
